import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";
import { type OfferedDiscount } from "@/types/types";

export function UserStays({
  title,
  offeredDiscount,
  onClose,
}: {
  title: string;
  offeredDiscount: OfferedDiscount | null;
  onClose: () => void;
}) {
  return (
    <div className="space-y-4">
      {offeredDiscount !== null && (
        <NormalText elementType="p">
          <NormalText elementType="span" className="font-semibold">
            {offeredDiscount.terms}
          </NormalText>{" "}
          will be applied to your next invoice.
        </NormalText>
      )}
      <NormalText elementType="p">{title}</NormalText>
      <CancelButtons
        positiveText="Close"
        negativeText={null}
        onPositive={onClose}
        onNegative={null}
      />
    </div>
  );
}
